module.exports = __webpack_public_path__ + "static/media/person_image.8aacc524.png";